import moment from "moment";
import { upperFirst, capitalize, toUpper } from "lodash";
import React from "react";
import FacebookFilled from "@ant-design/icons/es/icons/FacebookFilled";
import LinkedinFilled from "@ant-design/icons/es/icons/LinkedinFilled";
import InstagramFilled from "@ant-design/icons/es/icons/InstagramFilled";
import YoutubeFilled from "@ant-design/icons/es/icons/YoutubeFilled";
import LinkOutlined from "@ant-design/icons/es/icons/LinkOutlined";
import TwitterOutlined from "@ant-design/icons/es/icons/TwitterOutlined";
import GoogleOutlined from "@ant-design/icons/es/icons/GoogleOutlined";
import { ReactComponent as SalesNavigator } from "../assets/icons/linkedin-sales-navigator.svg";
import { ReactComponent as Indeed } from "../assets/icons/indeed.svg";
import { ReactComponent as Einforma } from "../assets/icons/einforma.svg";
import { ImWikipedia, ImPinterest } from "react-icons/im";
import {
  FaAppStoreIos,
  FaGooglePlay,
  FaMicrosoft,
  FaTiktok,
} from "react-icons/fa";
import locales from "../locales";
import { getFromLocalStorage } from "./helpers/localstorage";
import { bareLocalize } from "./localization";

export const getAddress = () =>
  `${global.location.protocol}//${global.location.host}/`;

// export const capitalizeFirstLetter = (string) =>
//   string.charAt(0).toUpperCase() + string.slice(1);

export const wait = (durationMs) =>
  new Promise((fulfill) => setTimeout(fulfill, durationMs));

export const refreshPage = () => {
  window.location.reload();
};

export const currencyDecimal = (value) => {
  return Number.parseFloat(value).toFixed(2).toString().concat(" €");
};

export const currencyNoDecimal = (value) => {
  return Number.parseFloat(value).toFixed(0).toString().concat("€");
};

export const isMobileDevice = () => window.screen.width < 767;

export const isTouchScreen = () =>
  !!("ontouchstart" in window || navigator.maxTouchPoints);

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const scrollToId = (id) => {
  const element = document.getElementById(id);
  // if (element) element.scrollIntoView();
  if (element) {
    const top = element.offsetTop;
    window.scrollTo({ top });
  }
};

export const getAge = (birthdate) => moment().diff(moment(birthdate), "years");

export const turnKeyIntoLabel = (key) => {
  if (key === "microsoft") return "Tiktok";
  return key && toTitleCase(key.replace(/(\_)/g, " "));
};

export const label = (schema, val, entity) => {
  const tenant = getFromLocalStorage("lefacWebTenant").data;
  if (entity) {
    let label;
    if (tenant) {
      label = bareLocalize(
        `SCHEMA.${tenant.toUpperCase()}.${entity.toUpperCase()}.${val.toUpperCase()}`,
      );
      if (label) return label;
    }
    label = bareLocalize(
      `SCHEMA.DEFAULT.${entity.toUpperCase()}.${val.toUpperCase()}`,
    );
    if (label) return label;
    console.log("label", label);
  }
  return val;
};

export const VALIDATE_MESSAGE = {
  required: "Il campo ${name} è obbligatorio",
  types: {
    email: "Il campo ${name} non è email valida!",
    number: "Il campo ${name} non è un numbero valido!",
  },
  number: {
    range: "Il campo ${name} deve essere compreso tra ${min} e ${max}",
  },
};

export const getEmailHelp = () => {
  const tenant = getFromLocalStorage("lefacWebTenant").data;
  //TODO: CAMBIARE NEL CASO IN CUI CI SARANNO EMAIL DIVERSE
  switch (tenant) {
    case "italy":
      return "helpdesk.it@blinkogroup.com";
    case "france":
      return "helpdesk.fr@blinkogroup.com";
    case "spain":
      return "marian@tbsiberia.es";
    case "portugal":
      return "marian@tbsiberia.es";
    case "uk":
      return "helpdesk.fr@blinkogroup.com";
    default:
      return "marian@tbsiberia.es";
  }
};

export const getGMapsFormattedAddress = (data) => {
  if (data && (data.address || data.company?.address)) {
    return (
      <div>
        <p>{(data.address ? data.address : data.company?.address) || "-"}</p>
        <p>
          {(data.CP ? `${data.CP} - ` : `${data.company?.CP} - `) || ""}
          {data.city ? data.city : data.company?.city}
          {data.province ? ` (${data.province}) - ` : ""}
          {data.region
            ? ` ${data.region}, `
            : data.company?.region
            ? ` ${data.company?.region}, `
            : ""}
          {data.nation ? data.nation : data.company?.nation}
        </p>
      </div>
    );
  }
  return "";
};

export const getGmapStringAddress = (data) => {
  if (data && (data.address || data.company?.address)) {
    return `${(data.address ? data.address : data.company?.address) || ""} ${
      data.CP ? `, ${data.CP}` : data.company?.CP ? `, ${data.company?.CP}` : ""
    } ${(data.city ? data.city : data.company?.city) || ""} ${
      (data.province ? data.province : data.company?.province) || ""
    }${
      data.region
        ? ` (${data.region})`
        : data.commpany?.region
        ? ` (${data.company?.region})`
        : ""
    }, ${(data.nation ? data.nation : data.company?.nation) || ""}`;
  }
  return "";
};

export const truncate = (input, val = 20) =>
  input && input.length > val ? `${input.substring(0, val)}...` : input;

export const flagMap = {
  italy: "it",
  france: "fr",
  spain: "es",
  mexico: "mx",
  germany: "de",
  portugal: "pt",
  uk: "gb",
};

export const imgPlaceholder =
  'data:image/png;base64,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"\n';

export const getUniqueList = (arr, key) => {
  return [...new Map(arr.map((item) => [item[key], item])).values()];
};

export const getSocialGraphLabel = (socialLabel) => {
  const text = socialLabel.split("_");
  if (text.length > 2) {
    return `${capitalize(text[1])} ${capitalize(text[2])}`;
  }
  return capitalize(text[1]);
};

export const getSocialIcon = (social) => {
  const customIconStyle = {
    width: 13,
    borderRadius: 3,
    height: 13,
    marginBottom: -2,
    marginRight: 5,
  };
  switch (social.label) {
    case "facebook":
      return <FacebookFilled style={{ color: "#3b5998" }} />;
    case "linkedin":
      return <LinkedinFilled style={{ color: "#0e76a8" }} />;
    case "instangram":
    case "instagram":
      return <InstagramFilled style={{ color: "#8134af" }} />;
    case "twitter":
      return <TwitterOutlined style={{ color: "#00acee" }} />;
    case "youtube":
      return <YoutubeFilled style={{ color: "#c4302b" }} />;
    case "google":
      return <GoogleOutlined style={{ color: "#fbbc05" }} />;
    case "sales_navigator":
      return <SalesNavigator style={customIconStyle} />;
    case "indeed":
      return <Indeed style={customIconStyle} />;
    // case "einforma":
    //   return <Einforma style={customIconStyle} />;
    case "wikipedia":
      return (
        <ImWikipedia
          style={{ marginBottom: -2, marginRight: 5, color: "#000000" }}
        />
      );
    case "pinterest":
      return (
        <ImPinterest
          style={{ marginBottom: -2, marginRight: 5, color: "#bd081c" }}
        />
      );
    case "ios":
      return (
        <FaAppStoreIos
          style={{ marginBottom: -2, marginRight: 5, color: "#3170d9" }}
        />
      );
    case "android":
      return (
        <FaGooglePlay
          style={{ marginBottom: -2, marginRight: 5, color: "#5bcafa" }}
        />
      );
    case "microsoft":
      return (
        <FaTiktok
          style={{ marginBottom: -2, marginRight: 5, color: "#46a2e9" }}
        />
      );
    default:
      return <LinkOutlined />;
  }
};

export const toTitleCase = (str) => {
  return str?.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const translateSchemaKey = (key, entity) => {
  const tenant = getFromLocalStorage("lefacTenant")?.data;
  const lang = getFromLocalStorage("lang")?.data;
  if (key && tenant && lang) {
    if (
      entity &&
      locales[lang]?.SCHEMA?.[tenant]?.[toUpper(entity)]?.[toUpper(key)]
    )
      return turnKeyIntoLabel(
        locales[lang]?.SCHEMA?.[tenant]?.[toUpper(entity)]?.[toUpper(key)],
      );
    if (locales[lang]?.SCHEMA?.[tenant]?.DEFAULT?.[toUpper(key)])
      return turnKeyIntoLabel(
        locales[lang]?.SCHEMA?.[tenant]?.DEFAULT?.[toUpper(key)],
      );
    if (
      entity &&
      locales[lang]?.SCHEMA?.DEFAULT?.[toUpper(entity)]?.[toUpper(key)]
    )
      return turnKeyIntoLabel(
        locales[lang]?.SCHEMA?.DEFAULT?.[toUpper(entity)]?.[toUpper(key)],
      );
    if (locales[lang]?.SCHEMA?.DEFAULT?.DEFAULT?.[toUpper(key)])
      return turnKeyIntoLabel(
        locales[lang]?.SCHEMA?.DEFAULT?.DEFAULT?.[toUpper(key)],
      );
  }
};

export const translateRegistryOnView = (id, translateEntity, isFlat) => {
  const lang = getFromLocalStorage("lang")?.data;
  const type = isFlat ? "FLAT" : "TREE";
  const fieldName = `${translateEntity}/${id}`;

  return locales[lang]?.BACKEND?.ENTITIES?.[type]?.[fieldName]?.NAME;
};

export const translateRegistryKeyFlatV2 = (id, entity, lang) => {
  const type = "FLATV2";
  const fieldName = `${entity}/${id}`;

  if (id && entity && lang) {
    return locales[lang]?.BACKEND?.ENTITIES?.[type]?.[fieldName]?.NAME;
  }
};

export const translateCompanyType = (id) => {
  const lang = getFromLocalStorage("lang")?.data;

  return locales[lang]?.SCHEMA?.DEFAULT?.TYPE?.[toUpper(id)]
    ? locales[lang]?.SCHEMA?.DEFAULT?.TYPE?.[toUpper(id)]
    : id;
};

export const currencyFormatter = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
});

// separate function to manage !, ', (, ), and * characters
export const encodeURIFix = (str) => {
  // return encodeURIComponent(str).replace(/!/g, "%21");
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
  });
};
